import type { SVGProps } from "react";

export function EmailSymbolIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 11.9998C16 13.0607 15.5786 14.0781 14.8284 14.8283C14.0783 15.5784 13.0609 15.9998 12 15.9998C10.9391 15.9998 9.92172 15.5784 9.17157 14.8283C8.42142 14.0781 8 13.0607 8 11.9998C8 10.939 8.42142 9.92157 9.17157 9.17142C9.92172 8.42127 10.9391 7.99985 12 7.99985C13.0609 7.99985 14.0783 8.42127 14.8284 9.17142C15.5786 9.92157 16 10.939 16 11.9998ZM16 11.9998V13.4998C16 14.1629 16.2634 14.7988 16.7322 15.2676C17.2011 15.7365 17.837 15.9998 18.5 15.9998C19.163 15.9998 19.7989 15.7365 20.2678 15.2676C20.7366 14.7988 21 14.1629 21 13.4998V11.9998C21.0025 10.0659 20.382 8.18269 19.2304 6.62904C18.0788 5.07539 16.4574 3.934 14.6064 3.37395C12.7554 2.81389 10.7732 2.86497 8.95343 3.51961C7.13371 4.17425 5.57324 5.39763 4.50321 7.00852C3.43317 8.61942 2.91047 10.5321 3.01255 12.4633C3.11463 14.3945 3.83605 16.2415 5.06995 17.7306C6.30385 19.2197 7.98459 20.2718 9.86319 20.7309C11.7418 21.1901 13.7183 21.0319 15.5 20.2798"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MailForwardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18H5C4.46957 18 3.96086 17.7893 3.58579 17.4142C3.21071 17.0391 3 16.5304 3 16V6M3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6M3 6L12 12L21 6M21 6V13.5M15 18H21M21 18L18 15M21 18L18 21"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MailLetterIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7M3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7M3 7L12 13L21 7"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
